export default {
      id: "steps-arrows-usage",
      viewBox: "0 0 47 57",
      url: __webpack_public_path__ + "sprite.svg#steps-arrows",
      toString: function () {
        return this.url;
      }
    }